// Formatting and color rules for the Forecasting tab's Email view
// (GET /api/admin/reporting/forecasting/email). Kept apart from the component so
// the thresholds are unit tested (ui/test/forecastEmail.test.js). Number and gap
// formatting is the Phone and Chat view's (forecastPhoneChat.js); only what is
// email's own lives here. A tone is 'error', 'warning' or null.
import { EM_DASH } from './forecastPhoneChat.js'

const r1 = (n) => Math.round(n * 10) / 10
const finite = (n) => typeof n === 'number' && Number.isFinite(n)

// Average hours to first answer ("9.4 h"); a missing value is a dash, never 0.
export function formatAvgHours(hours) {
  return finite(hours) ? `${r1(hours).toFixed(1)} h` : EM_DASH
}

// Speed of answer against its target: red over the target, amber within 20% of it.
// Judged on the number as shown, so "12.0 h" against 12 never reads red.
export function slaTone(avgHours, targetHours) {
  if (!finite(avgHours) || !finite(targetHours)) return null
  const v = r1(avgHours)
  return v > targetHours ? 'error' : v > targetHours * 0.8 ? 'warning' : null
}

// The Bright Pattern share of the weekly line, as a percent with one decimal.
// The seasonal index as a multiplier, "1.18×"; a dash with no index.
export function formatIndex(index) {
  return index == null ? '—' : `${index.toFixed(2)}×`
}

export function formatShare(fraction) {
  return finite(fraction) ? `${r1(fraction * 100).toFixed(1)}%` : EM_DASH
}

// "1A Email" and its target for a column header, "1A Email · 12 h".
export function slaHeader(row) {
  return finite(row?.targetHours) ? `${row.label} · ${row.targetHours} h` : row?.label ?? ''
}
